import WatchCTA from '#app/routes/resources+/watch-cta.tsx'
import { type Route } from './+types/discord.ts'

export const meta: Route.MetaFunction = () => [{ title: 'JaseOwns - Discord' }]

export default function TermsOfServiceRoute() {
	return <main className="container mx-auto text-black dark:text-white">
		<h1 className="text-3xl px-10 text-cyan-900 dark:text-cyan-200">JaseOwns Discord</h1>

		<div className="flex flex-col md:flex-row">
			<div className="p-6">
				<a href="https://discord.gg/w7375Tp"><img src="/images/emotes/yes_2048.png" alt="Yes emote" className='h-24 float-left m-8' /></a>
				<h3 className='text-3xl'>You got a discord Jase? I sure do!</h3>
				You should <a href="https://discord.gg/w7375Tp" className="underline">join the server</a> and ask questions, know when I go live or just get some cool emojis to use on your own server!
				<hr className='clear-both' />
				<div className="w-1/2 mt-8 clear-both">
					<h2 className="text-3xl text-cyan-900 dark:text-cyan-200">History</h2>
					<div className='m-8'>
						<b>January 3rd 2025 - 1968 members</b>
						<a href="https://discord.gg/w7375Tp">
							<img className="md:h-full md:w-full" alt="1968 Member Images" src="/images/discord/members_20250103.png" />
						</a>
					</div>
					<div className='m-8'>
						<b>April 28th 2024 - 918 members</b>
						<a href="https://discord.gg/w7375Tp">
							<img className="md:h-full md:w-full" alt="918 Member Images" src="/images/discord/members_20240428.png" />
						</a>
					</div>
				</div>
				

			</div>
			<div className="pl-6">
				<iframe className="text-center" src="https://discord.com/widget?id=442558623298617354&theme=dark" width="350" height="500" title="discord"></iframe>
			</div>
		</div>
		<div className="py-10"></div>
		{WatchCTA()}
	</main>
}
